<template>
  <div class="container my-5 py-md-5">
    <div v-bind:class="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-bind:class="result">
      <div class="row justify-content-center">
        <div class="col-md-10">
          <img class="img-fluid" src="static/img/header_uanl_facpsi.png" alt="">
        </div>
        <div class="col-md-8 mt-5">
          <div class="row">
          	<div class="col-12 text-center">
          		<h5><b>1) CUENTA CONCENTRADORA BANORTE</b></h5>
          	</div>
            <div class="col-12 mt-3 text-center">
              <h6><u>Folio de Registro: <b>{{solicitud.idsolicitud}}</b></u></h6>
            </div>
          	<div class="col-12 mt-3 text-center">
          		Se debe presentar  la siguiente información en ventanilla bancaria:
          	</div>
          	<div class="col-12 mt-3 text-center">
          		<h6><b>A) {{solicitud.concepto}}</b></h6>
          	</div>
          </div>
        </div>
        <div class="col-12 mt-3">
          <div class="row">
            <div class="col-4 text-right">
              <b>BANCO:</b>
            </div>
            <div class="col-8">
              {{solicitud.banco}}
            </div>
          </div>
          <div class="row">
            <div class="col-4 text-right">
              <b>NO. DE EMPRESA:</b>
            </div>
            <div class="col-8">
              {{solicitud.no_empresa}}
            </div>
          </div>
          <div class="row">
            <div class="col-4 text-right">
              <b>REFERENCIA:</b>
            </div>
            <div class="col-8">
              {{solicitud.referencia}}
            </div>
          </div>
          <div class="row">
            <div class="col-4 text-right">
              <b>NOMBRE:</b>
            </div>
            <div class="col-8">
              {{solicitud.nombre}}
            </div>
          </div>
          <div class="row">
            <div class="col-4 text-right">
              <b>CONCEPTO:</b>
            </div>
            <div class="col-8">
              {{solicitud.concepto}}
            </div>
          </div>
          <div class="row">
            <div class="col-4 text-right">
              <b>IMPORTE A PAGAR:</b>
            </div>
            <div class="col-8">
              {{solicitud.importe}}
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 text-center">
          <button v-on:click="Imprimir">Imprimir</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading:'d-none',
      result:'',
      solicitud:{
        idsolicitud:null,
        nombre: "",
        idconcepto: null,
        concepto: "",
        periodo_actual:"",
        banco:"",
        no_empresa:"",
        referencia:"",
        importe:0
      }
    }
  },
  methods:{
    Imprimir(){
      window.print();
    },
  	Consultar(){
  		this.Cargando();
  		this.$http.post('solicitudes/imprimir/registro',{
        idsolicitud:this.$route.params.idsolicitud,
        no_ceneval:this.$route.params.no_ceneval
      })
  		.then(respuesta=>{return respuesta.json()})
  		.then(respuestaJson=>{
  			if (respuestaJson.length>0) {
  				this.Listo();
          this.solicitud=respuestaJson[0];
  			}else{
  				this.$router.push({name:'Registro'});
  			  	swal("¡Ups!",'No encontre la solicitud', "error");
  			}
  		})
  		.catch(error=>{
  			this.$router.push({name:'Registro'});
  			swal("Favor de Intentar mas tarde", "Problemas para imprimir la solicitud de registro", "error");
  		});
  	},
  	Cargando(){
  		this.loading='';
  		this.result='d-none';
  	},
  	Listo(){
  		this.loading='d-none';
  		this.result='';
  	}
  },
  created(){
    localStorage.apikeySiepsBiologicasUanl=JSON.stringify("eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzaWVwc191YW5sX3Bvc2dyYWRvIiwiZGF0YSI6eyJpZHNvbGljaXR1ZCI6IjEiLCJpZGFsdW1ubyI6IjEifSwiaWF0IjoxNzE4ODM2MTM2LCJleHAiOjIwMzQzNjg5MzZ9.duBO5wP9M2_ttUAxXwcAIeIoxw0zom2Nlr0qX4RM7yg");
  },
  mounted(){
  	this.Consultar();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Imprimir_Registro.vue